import { NewMessageResponse } from "../../features/chat/domain/entities/onNewMessageSocket";

const shownMessageIds = new Set<string>();

export const resetIncomingChatBrowserNotificationDedupe = () => {
	shownMessageIds.clear();
};

export const showIncomingChatBrowserNotification = (
	incoming: NewMessageResponse
) => {
	if (typeof window === "undefined" || typeof Notification === "undefined") return;
	if (Notification.permission !== "granted") return;

	const messageId = incoming.message.message_id;
	if (!messageId || shownMessageIds.has(messageId)) return;

	const messageFromOtherUser =
		incoming.message.sender_id === incoming.chat.user_id ||
		incoming.message.message_sender_id === incoming.chat.user_id;
	if (!messageFromOtherUser) return;

	shownMessageIds.add(messageId);

	const senderName = incoming.chat.username || "New message";
	const text = incoming.message.message_text?.trim();
	const body = text ? `${senderName}: ${text}` : `${senderName} sent a message`;

	try {
		const notification = new Notification("New message", {
			body,
			icon: "/hookup4u-Logo-BP.png",
			tag: `message-${incoming.chat.chat_id}`,
		});

		notification.onclick = () => {
			window.focus();
			window.location.assign(`/messages/${incoming.chat.user_id}`);
			notification.close();
		};
	} catch {
		// Some browser modes can block foreground notifications even after permission.
	}
};
